<template>
  <MarketingShell>
    <StoryDetail :story="story" />
    <MoreStories :current-slug="story.slug" />
  </MarketingShell>
</template>

<script>
import MarketingShell from '@/components/landing/MarketingShell';
import StoryDetail from '@/components/successStories/StoryDetail';
import MoreStories from '@/components/successStories/MoreStories';
import { updatePageMeta } from '@/utils/useHeadUtils';

export default {
  components: {
    MarketingShell,
    StoryDetail,
    MoreStories,
  },
  props: {
    story: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    updatePageMeta({
      title: `${this.story.title} — Site Palette`,
      description: this.story.excerpt,
      path: `/success-stories/${this.story.slug}`,
    });
  },
};
</script>
